import * as preact from 'preact'
const { h, Component } = preact
import * as styles from './style.css'
import PureComponent from '../../../lib/preact-pure-component'

interface Props {
  photographer: string
  type: string
  style?: string
}

export class PhotoCredit extends PureComponent<Props, {}> {
  render() {
    const { type, photographer } = this.props
    const mediaType = type === 'video' ? 'Video' : 'Foto'
    return (
      <div className={styles.wrapper}>
        <div className={styles.photocredit}>{`${mediaType}: ${photographer}`}</div>
      </div>
    )
  }
}
